import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({providedIn:'root'})
export class CheckinDeviceService {
  constructor(private http: HttpClient) {}
  private key() { return 'CSCheckinDevice:' + (localStorage.getItem('tenant') || ''); }
  read(): {userId:string; token:string} | null {
    try { const value = JSON.parse(localStorage.getItem(this.key()) || 'null'); return value?.userId && /^[A-Fa-f0-9]{64}$/.test(value.token) ? value : null; }
    catch { return null; }
  }
  save(userId: string, token: string) {
    if (!userId || !/^[A-Fa-f0-9]{64}$/.test(token || '')) return;
    localStorage.setItem(this.key(), JSON.stringify({userId, token}));
    localStorage.setItem('CSBarcodeID', userId);
  }
  async remember(): Promise<void> {
    const result = await this.http.post<any>(environment.apiHost + '/AccountAccess/Remember', {}).toPromise();
    this.save(result.userId, result.checkinDeviceToken);
  }
  async forget(): Promise<void> {
    const device = this.read();
    if (device) await this.http.post(environment.apiHost + '/AccountAccess/Forget', {userId:device.userId}, {headers:{'X-Checkin-Device':device.token}}).toPromise();
    this.clear();
  }
  clear() { localStorage.removeItem(this.key()); localStorage.removeItem('CSBarcodeID'); }
  emailOptions(email: string) {
    return this.http.post<any>(environment.apiHost + '/AccountAccess/EmailOptions', {email}).toPromise();
  }
  emailLink(email: string, returnUrl = '') {
    return this.http.post<any>(environment.apiHost + '/AccountAccess/EmailLink', {email, returnUrl}).toPromise();
  }
}
